import { createSelector } from 'reselect'

import { selectMarketInfoState } from './selectMarketInfoState'

export const selectMarketInfo = createSelector(
  [selectMarketInfoState],
  (marketInfo) => marketInfo.data
)
